<template>
	<div class="bg-white px-3" style="margin-left: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="py-2 border-bottom d-flex align-items-center">
			<el-button type="primary" size="mini" @click="openModel('lhlx')" icon="el-icon-plus">添加</el-button>
		</div>
		<div>
			<el-table
				:data="lhlxList"
				style="width: 100%"
				size="mini"
				row-key="id"
				:tree-props="{ children: 'child', hasChildren: 'hasChildren' }"
				@current-change="handleCurrentChange"
				:max-height="maxHeight"
			>
				<el-table-column type="index" width="50"></el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">
						名称
					</template>
					<template slot-scope="scope">
						{{ scope.row.name }}
					</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">
						平时价
					</template>
					<template slot-scope="scope">
						{{ scope.row.psj }}
					</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">
						节假日
					</template>
					<template slot-scope="scope">
						{{ scope.row.jjr }}
					</template>
				</el-table-column>
				<el-table-column>
					<template slot="header" slot-scope="scope">
						加班价
					</template>
					<template slot-scope="scope">
						{{ scope.row.jbj }}
					</template>
				</el-table-column>
				<el-table-column width="160">
					<template slot="header" slot-scope="scope">
						创建时间
					</template>
					<template slot-scope="scope">
						{{ scope.row.create_time }}
					</template>
				</el-table-column>

				<el-table-column align="center" width="190">
					<template slot="header" slot-scope="scope">
						操作
					</template>
					<template slot-scope="scope">
						<el-button type="primary" size="mini" @click="openModel('lhlx', scope.row)">编辑</el-button>
						<el-button type="danger" size="mini" @click="deleteItem(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;z-index: 100;width: 100%;margin-left: -20px;">
			<div style="flex: 1;" class="px-2">
				<el-pagination
					:current-page="page.current"
					:page-sizes="page.sizes"
					:page-size="page.size"
					layout="total, sizes, prev, pager, next, jumper"
					:total="page.total"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				></el-pagination>
			</div>
		</el-footer>
		<el-dialog title="类别详情" :visible.sync="createModel" top="10vh">
			<!-- 表单内容 -->
			<div style="width: 100%;margin-top: 20px;" class="d-flex">
				<el-form v-if="preUrl === 'lhlx'" ref="form" :model="form.lhlx" label-width="80px">
					<el-form-item label="名称">
						<el-input v-model="form.lhlx.name" size="mini" style="width: 95%;"></el-input>
					</el-form-item>
					<el-form-item label="平时价">
						<el-input-number size="mini" v-model="form.lhlx.psj" style="width: 90%;" :min='0' :precision="2"></el-input-number>
					</el-form-item>
					<el-form-item label="节假日">
						<el-input-number size="mini" v-model="form.lhlx.jjr" style="width: 90%;" :min='0' :precision="2"></el-input-number>
					</el-form-item>
					<el-form-item label="加班价">
						<el-input-number size="mini" v-model="form.lhlx.jbj" style="width: 90%;" :min='0' :precision="2"></el-input-number>
					</el-form-item>
				</el-form>
			</div>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	data() {
		return {
			form: {
				lhlx: {}
			},
			createModel: false,
			dialogType: 'lhlx',
			preUrl: 'lhlx', //api
			dialogId: 0,
			lhlxList: [],
			maxHeight: 0,
		};
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 240;
		});
	},
	methods: {
		getListUrl() {
			return `/admin/${this.preUrl}/${this.page.current}?limit=${this.page.size}`;
		},
		// 处理列表结果
		getListResult(e) {
			this.lhlxList = e.list;
			console.log(this.lhlxList);
		},
		openModel(type, item = false) {
			// 初始化表单
			switch (type) {
				// 初始化添加管理员
				case 'lhlx':
					if (!item) {
						this.form.lhlx = {
							id: '',
							name: '',
							jjr:0.00,
							psj:0.00,
							jbj:0.00
						};
						this.dialogId = 0;
					} else {
						this.form.lhlx = {
							name: item.name,
							jjr:item.jjr,
							psj:item.psj,
							jbj:item.jbj
						};
						this.dialogId = item.id;
					}
					break;
			}
			// 打开dialog
			this.createModel = true;
		},
		submit() {
			let f = this.form.lhlx;
			let e = {
				name: f.name,
				jjr:f.jjr,
				psj:f.psj,
				jbj:f.jbj,
				cjr: this.user.id
			};
			this.addOrEdit(e, this.dialogId);
			this.createModel = false;
		},
		handleCurrentChange(val) {
			this.currentRow = val;
		}
	}
};
</script>

<style></style>
